import React from 'react';
import { menuListItems } from '../../assets/menu/menuList';
import { Menu } from '../../components/Menu';
import { AccountDeletionsTable } from './AccountDeletionsTable';
import { Container } from './styles';

export const AccountDeletions: React.FC = () => {
  return (
    <Menu links={menuListItems}>
      <Container>
        <AccountDeletionsTable />
      </Container>
    </Menu>
  );
};
